<app-simple-modal-header
	[pageTitle]="pageTitle"
	(dismissed)="dismiss()"
></app-simple-modal-header>

<ion-content>
	<form [formGroup]="form" *ngIf="form">
		<ion-item>
			<ion-label position="stacked">Subject:</ion-label>
			<div class="subject">{{ subject }}</div>
		</ion-item>
		<ion-item>
			<ion-label position="stacked">Note:</ion-label>
			<ion-textarea
				[formControl]="form.controls.comment"
				autofocus="true"
				rows="10"
			></ion-textarea>
			<div
				*ngIf="
					form.controls.comment.errors && isFormSubmitted === false
				"
				class="error-text"
			>
				Comment must be at least 5 characters long.
			</div>
		</ion-item>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		expand="full"
		class="modal__submit"
		color="primary"
		(click)="onClickSave()"
	>
		Add Comment
	</ion-button>
</ion-footer>
